"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldSubForm = exports.ModelMutatorSubForm = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var id_1 = require("../../../id");
var collection_base_1 = require("../collection.base");
var collection_field_1 = require("../collection.field");
var ModelMutatorSubForm = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorSubForm, _super);
    function ModelMutatorSubForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new subForm instance
     * @param id (Optional) instanceId
     * @returns the instanceId of the instance created.
     */
    ModelMutatorSubForm.prototype.create = function (id) {
        if (id == null || id === '') {
            id = id_1.IkeId.generate(10);
        }
        var instanceIds = this.getStateValue();
        if (instanceIds.indexOf(id) !== -1) {
            throw new Error("Subform instance id must be unique: ".concat(id));
        }
        instanceIds.push(id);
        this.state.setFieldValue(this.field.id, instanceIds);
        return id;
    };
    ModelMutatorSubForm.prototype.clear = function () {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(this.field.value), _c = _b.next(); !_c.done; _c = _b.next()) {
                var instance = _c.value;
                this.clearInstance(instance);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.state.setFieldValue(this.field.id, null);
    };
    ModelMutatorSubForm.prototype.remove = function (instanceId) {
        var instanceIds = this.getStateValue();
        var index = instanceIds.indexOf(instanceId);
        if (index === -1) {
            throw new Error("Cannot remove subform. Instance \"".concat(instanceId, "\" is missing from subform \"").concat(this.field.id, "\""));
        }
        this.clearInstance(this.field.value[index]);
        instanceIds.splice(index, 1);
        delete this.field.instances[instanceId];
        this.field.collection.state.setFieldValue(this.field.id, instanceIds);
    };
    ModelMutatorSubForm.prototype.getStateValue = function () {
        var stateValue = this.field.stateValue;
        if (Array.isArray(stateValue)) {
            return stateValue.slice();
        }
        return [];
    };
    ModelMutatorSubForm.prototype.clearInstance = function (instance) {
        var e_2, _a;
        try {
            for (var _b = tslib_1.__values(instance.schema.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var fieldSchema = _c.value;
                if (instance.hasField(fieldSchema.id)) {
                    instance.getField(fieldSchema.id).Mutator.clear();
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    /**
     * Copies all subform instances from the target into this subform.
     *
     * @param from Subform to copy from.
     */
    ModelMutatorSubForm.prototype.copy = function (from) {
        var e_3, _a;
        var hasCopied = true;
        try {
            for (var _b = tslib_1.__values(from.value), _c = _b.next(); !_c.done; _c = _b.next()) {
                var instance = _c.value;
                var createdInstanceId = this.create();
                var newInstance = this.field.getInstance(createdInstanceId);
                var fieldCopied = this.copyFields(instance, newInstance);
                if (!fieldCopied) {
                    hasCopied = false;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return hasCopied;
    };
    /**
    * Copies a specific subform instance from the target into this subform.
    *
    * @param from Subform to copy from.
    * @param instanceId Specific instance to copy.
    * @param linkId Whether the new instance should have the same instanceId as the original.
    */
    ModelMutatorSubForm.prototype.copyInstance = function (from, instanceId, linkId) {
        var instance = from.getInstance(instanceId);
        if (instance == null) {
            return null;
        }
        var newInstanceId = this.create(linkId ? instanceId : null);
        var newInstance = this.field.getInstance(newInstanceId);
        var hasCopied = this.copyFields(instance, newInstance);
        return hasCopied ? newInstance : null;
    };
    ModelMutatorSubForm.prototype.copyFields = function (from, to) {
        var e_4, _a;
        var hasCopied = true;
        try {
            for (var _b = tslib_1.__values(from.schema.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var schemaField = _c.value;
                var field = from.getField(schemaField.id);
                var newField = to.getField(schemaField.id);
                var fieldCopied = newField.Mutator.copy(field);
                if (!fieldCopied) {
                    hasCopied = false;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return hasCopied;
    };
    return ModelMutatorSubForm;
}(collection_field_1.ModelMutator));
exports.ModelMutatorSubForm = ModelMutatorSubForm;
var CollectionModelFieldSubForm = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldSubForm, _super);
    function CollectionModelFieldSubForm() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.instances = {};
        return _this;
    }
    CollectionModelFieldSubForm.isSubFormField = function (f) {
        return f.schema.type === CollectionModelFieldSubForm.TYPE;
    };
    Object.defineProperty(CollectionModelFieldSubForm.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorSubForm(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldSubForm.prototype, "value", {
        get: function () {
            var e_5, _a;
            var stateValue = this.stateValue;
            if (!Array.isArray(stateValue)) {
                return [];
            }
            var output = [];
            try {
                for (var stateValue_1 = tslib_1.__values(stateValue), stateValue_1_1 = stateValue_1.next(); !stateValue_1_1.done; stateValue_1_1 = stateValue_1.next()) {
                    var instanceId = stateValue_1_1.value;
                    output.push(this.getOrCreateInstance(instanceId));
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (stateValue_1_1 && !stateValue_1_1.done && (_a = stateValue_1.return)) _a.call(stateValue_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
            return output;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldSubForm.prototype.getOrCreateInstance = function (instanceId) {
        var existing = this.instances[instanceId];
        if (existing == null) {
            existing = this.instances[instanceId] = new collection_base_1.CollectionModelFieldSubFormInstance(this, instanceId, this.schema);
        }
        return existing;
    };
    CollectionModelFieldSubForm.prototype.getInstance = function (instanceId) {
        var stateValue = this.stateValue;
        if (!Array.isArray(stateValue)) {
            return null;
        }
        var hasInstance = stateValue.indexOf(instanceId) > -1;
        if (hasInstance) {
            return this.getOrCreateInstance(instanceId);
        }
        return null;
    };
    CollectionModelFieldSubForm.prototype.mustGetInstance = function (instanceId) {
        var instance = this.getInstance(instanceId);
        if (!instance) {
            throw new Error("mustGetInstance: failed to get instance with id ".concat(instanceId));
        }
        return instance;
    };
    CollectionModelFieldSubForm.prototype.hasValue = function () {
        var stateValue = this.stateValue;
        if (!Array.isArray(stateValue)) {
            return false;
        }
        return this.stateValue.length > 0;
    };
    CollectionModelFieldSubForm.TYPE = core_api_1.IkeFieldType.FORM;
    return CollectionModelFieldSubForm;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldSubForm = CollectionModelFieldSubForm;
//# sourceMappingURL=form.field.js.map